import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "3c16d32c-2ecf-4863-9049-0705468fdaac", content: "maximum at fs", options: {} },
  {
    id: "b0e00376-0254-49d0-b414-21c40ce77de6",
    content: "in phase opposition with that<br>of the vent at very low frequencies",
    options: {},
  },
  { id: "3b2108fd-7f95-421b-9d9f-270b7aaa59d3", content: "equal to that of the vent at high frequencies", options: {} },
  {
    id: "1b2ba55c-b9ec-47d7-886a-f616d60f9312",
    content: "controlled by V<sub>b</sub> at  high-frequencies ",
    options: {},
  },
  { id: "69c24dce-fbdb-49cf-8cb5-85b7921ab046", content: "minimum at f<sub>s</sub>", options: {} },
  {
    id: "b09e37cf-7cd8-4973-865e-dee29aaf4199",
    content: "controlled by C<sub>ms</sub> at  high-frequencies ",
    options: {},
  },
];

export const task: Task = {
  id: "3570a24b-64cb-4b17-98be-589e85dfd23a",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["b0e00376-0254-49d0-b414-21c40ce77de6", "69c24dce-fbdb-49cf-8cb5-85b7921ab046"],
};
